import React from "react";
import { motion } from "framer-motion";
import { Navbar } from "../../components/user-components/NavigationBar/Navbar";
import { ProjectHead } from "../../components/user-components/Header/ProjectHead";
import { Projectme } from "../../components/user-components/Projectme/Projectme";
import { Projectme2 } from "../../components/user-components/Projectme/Projectme2";
import { ScrollTop } from "../../config/ScrollTop";

const pageVariants = {
  initial: {
    opacity: 0,
    y: 50,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.5,
    },
  },
};

export const Projects = () => {
  return (
    <>
      <Navbar />
      <ProjectHead />
      <motion.div
        initial="initial"
        animate="animate"
        variants={pageVariants}
        exit="initial"
      >
        <motion.div className="pt-5">
          <Projectme />
          <Projectme2 />
        </motion.div>
      </motion.div>
      <ScrollTop />
    </>
  );
};
